import React from 'react';
import { Button } from '../components/Button';
import { Dial } from '../components/Dial';
import { usePageMeta } from '../hooks/usePageMeta';
export function NotFound() {
  usePageMeta('Page not found', 'This page could not be found.');
  return <section className="gutter section flex flex-col items-center text-center" data-id="element-795" data-mp="107z6twpg2emm">
      <Dial className="w-[min(60vw,16rem)]" data-id="element-796" data-mp="156iv43rig2i5" />
      <h1 className="t-h2 mt-10" data-id="element-797" data-mp="1a42ax83uwnc7">Out of time.</h1>
      <p className="mt-4 text-graphite" data-id="element-798" data-mp="1a3j0sdkg738q">The page you're looking for isn't here.</p>
      <Button to="/" className="mt-8" data-id="element-799" data-mp="1f23r9l9we8jz">
        Return Home
      </Button>
    </section>;
}